import { ApolloError } from '@apollo/client';

let sentryLib: typeof import('./importSentry') | null = null;
let sentryImportPromise: Promise<typeof import('./importSentry')> | null = null;

const init = (SentryLib: typeof import('./importSentry')) => {
  // Do not init client Sentry on SSR
  if (typeof window === 'undefined') {
    return;
  }
  if (sentryLib) {
    return;
  }
  SentryLib.init({
    dsn: SENTRY_DSN,
    release: SENTRY_RELEASE,
    integrations: (integrations) => {
      const excludedIntegrations = [
        'BrowserTracing',
        'BrowserSession',
      ];

      return integrations.filter(
        (integration) => {
          return !excludedIntegrations.includes(integration.name);
        },
      );
    },
    beforeSend: (event, hint) => {
      const originalException = hint?.originalException;

      // Apollo errors have to be captured in apollo-link-error
      if (originalException instanceof ApolloError) {
        return null;
      }

      return event;
    },
    ignoreErrors: [
      // Errors from external resources (frames)
      /^SecurityError:/,

      // Network errors
      /^Loading CSS chunk/,
      /^ChunkLoadError:/,
      /^UnhandledRejection: Non-Error promise rejection captured with value: Timeout/,
      'TypeError: Failed to fetch',
    ],
    allowUrls: [SENTRY_BASE_WHITE_URL],
    maxBreadcrumbs: 5,
    sendClientReports: false,
  });

  if (window.VID) {
    SentryLib.setUser({
      id: String(window.VID),
    });
  }
  sentryLib = SentryLib;
};

const importSentry = async () => {
  if (!sentryImportPromise) {
    sentryImportPromise = import('./importSentry');
  }
  return sentryImportPromise;
};

export const getSentry = async () => {
  if (!sentryLib) {
    const importedSentry = await importSentry();
    init(importedSentry);
    return importedSentry;
  }

  return sentryLib!;
};

export const initSentryIdle = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(getSentry);
  } else {
    setTimeout(() => {
      getSentry();
    }, 2000);
  }
};


